module.exports = __webpack_public_path__ + "static/img/home_active@2x.d5ba7c51.png";